import React from 'react';
import styled from 'styled-components';
import { mediaBreakpointDown } from '../../utils/styling';
import Link from '../Link';

const FooterContainer = styled.footer`
	background-color: rgba(240, 245, 248, 0.5);
	padding: 64px 20px 30px;
`;
const FooterContent = styled.div`
	padding: 30px;
	display: flex;
	flex-direction: column;
	position: relative;
	max-width: 1500px;
	margin: 0 auto;
	${mediaBreakpointDown('md')} {
		padding: 0;
	}
`;

const NavigationList = styled.ul`
	display: flex;
	margin: 0 0 35px 0;
	padding: 0;
	flex-wrap: wrap;
	justify-content: center;
	${mediaBreakpointDown('md')} {
		flex-direction: column;
	}
`;
const NavigationItem = styled.li`
	list-style: none;
	margin: 0 0 20px 0;
	padding: 15px 0;
	display: flex;
	flex-direction: row;
	${mediaBreakpointDown('md')} {
		border-bottom: 1px solid #ced8e1;
		margin: 0;
	}
	:last-child {
		margin: 0;
		border-bottom: none;
	}
	> a {
		color: rgba(181, 186, 196, 0.8);
		font-size: 13px;
		text-transform: uppercase;
		font-weight: 700;
		padding: 0;
		display: block;
		transition: all 0.3s ease-in-out 0s;

		:hover {
			color: #323a56;
		}
	}
`;
const Terms = styled.p`
	display: block;
	text-align: center;
	font-size: 16px;
	line-height: 2;
	letter-spacing: -0.68px;
	color: #8796a8;
	margin: 25px 0;
	font-weight: 500;
`;

const TermsOutline = styled.span`
	display: inline-block;
	padding: 1px;
	background-color: #DB33F9;
	color: #fff;
	margin-right: 3px;
	margin-top: -1px;
	&: hover{
		background-color: transparent;
		color: #DB33F9;
	}
`;

const Pipe = styled.span`
	margin: 0 5px;
	color: rgba(181, 186, 196, 0.8);
	font-weight: 400;

	${mediaBreakpointDown('md')} {
		display: none;
	}
`;

const footer = {
	menuItems: {
		nodes: [
			{
				label: 'Home',
				linkRelationship: null,
				target: null,
				url: 'https://donotpay.com',
			},
			{
				label: 'Sign Up/Sign In',
				linkRelationship: 'nofollow',
				target: null,
				url: 'https://donotpay.com/login',
			},
			{
				label: 'Learn',
				linkRelationship: null,
				target: null,
				url: '/',
			},
			{
				label: 'Cancel Services',
				linkRelationship: null,
				target: null,
				url: '/how-to-cancel/',
			},
			{
				label: 'Free Trials',
				linkRelationship: null,
				target: null,
				url: '/free-trials/',
			},
			{
				label: 'Refunds',
				linkRelationship: null,
				target: null,
				url: '/chargebacks-and-refunds/',
			},
			{
				label: 'Clinical Trials',
				linkRelationship: null,
				target: null,
				url: '/clinical-trials/',
			},
			{
				label: 'Unclaimed Money',
				linkRelationship: null,
				target: null,
				url: '/missing-money/',
			},
			{
				label: 'Government Tests',
				linkRelationship: null,
				target: null,
				url: '/government-tests-prep/',
			},
			{
				label: 'Online Fax',
				linkRelationship: null,
				target: null,
				url: '/online-fax/',
			},
			{
				label: 'FOIA',
				linkRelationship: null,
				target: null,
				url: '/freedom-of-information-act/',
			},
			{
				label: 'Late Delivery Refunds',
				linkRelationship: null,
				target: null,
				url: '/late-delivery-refunds/',
			},
			{
				label: 'Terms',
				linkRelationship: null,
				target: null,
				url: 'https://www.donotpay.com/terms-of-service/',
			},
			{
				label: 'About',
				linkRelationship: null,
				target: null,
				url: 'https://www.donotpay.com/about/',
			},
		],
	},
};

const currentYear = new Date().getFullYear();
function Footer() {

	return (
		<FooterContainer>
			<FooterContent>
				<NavigationList>
					{footer.menuItems.nodes.map((item) => {

						if (item.label === "Terms") {
							return (
								<NavigationItem key={item.url}>
									<Link to={"https://www.donotpay.com/learn/terms-of-service/"}><TermsOutline>Terms of service</TermsOutline> </Link>
									<Link to={"https://www.donotpay.com/learn/privacy-policy/"}>{" & Privacy Policy"} </Link>
									{item.url !== 'https://www.donotpay.com/about/' && <Pipe> | </Pipe>}
								</NavigationItem>
							)
						}
						return (
							<NavigationItem key={item.url}>
								<Link to={item.url}>{item.label} </Link>
								{item.url !== 'https://www.donotpay.com/about/' && <Pipe> | </Pipe>}
							</NavigationItem>
						);
					})}
				</NavigationList>
				<Terms>© {`${currentYear}`} DoNotPay All rights reserved.</Terms>
			</FooterContent>
		</FooterContainer>
	);
}

export default React.memo(Footer);
